var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item.SON)?_c('div',{staticClass:"branch"},_vm._l((_vm.item.children),function(child,i){return _c('div',{key:i,staticClass:"entry"},[_c('span',{class:`bg-${child.bg}`},[_vm._v(_vm._s(_vm.name(child.ADDR)))]),_c('node',{attrs:{"item":child}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }